import Loadable from 'react-loadable';

export const Ac2ServiceDoc = Loadable({
  loader: () => import('./Ac2ServiceDoc'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./src/containers/Ac2ServiceDoc/index.ts